import React from "react";
import {
  Box,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
  Checkbox,
} from "@mui/material";
import JumpAccountingLogo from "../../assets/logo/JumpAccountingLogo.png";
import ExtraTicks from "../../assets/ExtraTicks.svg";
import Ashwini from "../../assets/Ashwini.png";
import Quickbooks from "../../assets/logo/Quickbooks.svg";

const AdvisoryPage = () => {
  const services = [
    "EIS & SEIS applications",
    "R&D tax credits",
    "Grant application advise",
    "Business valuations",
    "EMI option schemes",
    "Financial forecasting",
    "Business advisory",
    "Fundraising advisory",
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        ml: 6,
        p: 4,
        bgcolor: "#f4f7fb",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          maxWidth: "1200px",
        }}
      >
        <Box sx={{ mb: 4, width: "100%", maxWidth: "850px" }}>
          <img
            src={JumpAccountingLogo}
            alt="JumpAccountingLogo"
            width={"200px"}
            style={{ cursor: "pointer" }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.02)";
              e.currentTarget.style.opacity = "0.6";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.opacity = "1";
            }}
            onClick={() => {
              window.open("https://www.jumpaccounting.co.uk/", "_blank");
            }}
          />
          <Typography sx={{ fontSize: "1.1rem" }}>
            Whether you’re seeking to raise capital or implement an Employee
            Option Scheme, we have the expertise to support your needs.
          </Typography>
        </Box>
        <Button
          sx={{
            borderRadius: "5px",
            height: "40px",
            backgroundColor: "#2468FF",
            color: "#ffffff",
            marginTop: "1rem",
            marginLeft: "0.5rem",
            fontWeight: 600,
            padding: "0.5rem 1.5rem",
            textTransform: "none",
            width: "max-content",
            "&:hover": {
              backgroundColor: "#b4a4f5",
            },
          }}
          onClick={() => {
            window.open("https://jumpaccounting.co.uk", "_blank");
          }}
        >
          Find out more
        </Button>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          maxWidth: "1200px",
        }}
      >
        <Box
          sx={{
            flex: 1,
            p: 3,
            bgcolor: "#FFFFFF",
            borderRadius: "10px",
            mr: 8,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Advisory Services to Grow and Scale
          </Typography>
          <List>
            {services.map((service, index) => (
              <ListItem key={index} sx={{ padding: "0.25rem 0", mt: 0.5 }}>
                <img src={ExtraTicks} alt="ExtraTicks" width={"35px"} />
                <Typography sx={{ ml: 2, fontSize: "1.1rem" }}>
                  {service}
                </Typography>
              </ListItem>
            ))}
          </List>
        </Box>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: 2,
            maxWidth: "500px",
          }}
        >
          <Box
            sx={{
              bgcolor: "#FFFFFF",
              borderRadius: "10px",
              p: 3,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                maxWidth: "250px",
              }}
            >
              <Typography
                sx={{ fontSize: "1.1rem", fontWeight: "medium" }}
                gutterBottom
              >
                Advisory Services to Grow and Scale
              </Typography>

              <Button
                variant="contained"
                color="primary"
                sx={{
                  borderRadius: "5px",
                  height: "40px",
                  backgroundColor: "#2468FF",
                  color: "#ffffff",
                  marginTop: "1rem",
                  marginLeft: "0.5rem",
                  fontWeight: 600,
                  padding: "1rem 2rem",
                  textTransform: "none",
                  width: "max-content",
                  "&:hover": {
                    backgroundColor: "#b4a4f5",
                  },
                }}
                onClick={() => {
                  window.open(
                    "https://meetings.hubspot.com/ashwini-prasad/advisory-service-call",
                    "_blank"
                  );
                }}
              >
                Book a call
              </Button>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <img
                src={Ashwini}
                alt="Team member"
                style={{
                  width: "120px",
                  height: "125px",
                  marginRight: "1rem",
                }}
              />
            </Box>
          </Box>

          <Box
            sx={{
              bgcolor: "#0D333F",
              borderRadius: "10px",
              p: 3,
              display: "flex",
              justifyContent: "space-between",
              marginTop: "10px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                maxWidth: "250px",
              }}
            >
              <Typography
                sx={{ fontSize: "1.1rem", fontWeight: "medium", color: "#fff" }}
                gutterBottom
              >
                Claim your discounted Quickbooks Accounting Software package
                today.
              </Typography>

              <Button
                variant="contained"
                color="primary"
                sx={{
                  borderRadius: "5px",
                  height: "40px",
                  backgroundColor: "#fff",
                  color: "#000",
                  marginTop: "1rem",
                  marginLeft: "0.5rem",
                  fontWeight: 600,
                  padding: "1rem 2rem",
                  textTransform: "none",
                  width: "max-content",
                  "&:hover": {
                    backgroundColor: "#b4a4f5",
                  },
                }}
                onClick={() => {
                  window.open(
                    "https://quickbooks.partnerlinks.io/qb-discounted-pricing-plans",
                    "_blank"
                  );
                }}
              >
                Find out more
              </Button>
            </Box>
            <Box sx={{ display: "flex" }}>
              <img
                src={Quickbooks}
                alt="Team member"
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  marginRight: "1rem",
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AdvisoryPage;
